<template></template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {AtomSpinner, HollowDotsSpinner} from 'epic-spinners'

export default {
  name: "Filters",
  props: {},
  data(){
    return{}
  },
  components: {
    AtomSpinner,
    HollowDotsSpinner
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}

}
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {}

@media (min-width: 768px) {}

@media (min-width: 992px) {}
</style>



// WEBPACK FOOTER //
// src/components/shared/Filters.vue